export default __webpack_public_path__ + "static/media/TC.aa974e8d.svg";